import { defineMessages } from "react-intl";

export const messages = defineMessages({
  manageApp: {
    id: "LwX0Ug",
    defaultMessage: "Manage app",
    description: "Button with Manage app label",
  },
  appSettings: {
    id: "S90DJO",
    defaultMessage: "App settings",
    description: "Button with  app settings label",
  },
});
